import { lazy } from 'react'

import { SignInForm } from './components/signInForm'
import { Registration } from './components/registration'
import { Join } from './components/registration/join'
import { ResetPassword } from './components/resetPassword'
import { LookupUsername } from './components/lookupUsername'
import { NavianceLinkAccount } from './components/registration/panels/navianceLinkAccount'

const Authorization = lazy(async () => {
  const { Authorization: AuthorizationModule } = await import(
    /* webpackChunkName: "registration-authorization" */ './components/registration/join/authorization'
  )

  return {
    default: AuthorizationModule
  }
})
const routes = [
  {
    path: '/signin',
    exact: true,
    render(props) {
      return <SignInForm allowRedirect {...props} />
    }
  },
  {
    path: '/register',
    exact: true,
    render(props) {
      return <Registration {...props} />
    }
  },
  {
    path: '/accept/:code?',
    render(props) {
      return <Join {...props} />
    }
  },
  {
    path: '/confirm/:code',
    render({ match }) {
      return <Authorization code={match.params.code} />
    }
  },
  {
    path: '/resetpassword',
    exact: true,
    render(props) {
      return <ResetPassword {...props} />
    }
  },
  {
    path: '/lookupuser',
    exact: true,
    render(props) {
      return <LookupUsername {...props} />
    }
  },
  {
    path: '/naviancelinkaccount/:type',
    render(props) {
      return <NavianceLinkAccount {...props} />
    }
  }
]

export { routes }
